import React from 'react';
import {connect} from 'react-redux';
import Breadcrumbs from '@homeaway/react-breadcrumbs';
import {pushEdapEvent} from '../../../utils/edap';

import './style.less';

export function mapStateToProps(state) {
    return {
        breadcrumbs: state.modules.breadcrumbs
    };
}

function breadcrumbClickHandler(breadcrumbs) {
    return (event, crumb) => {
        const isHome = breadcrumbs.indexOf(crumb) === 0;

        const edapData = {
            actionlocation: 'destination-breadcrumb',
            eventlbsuuid: isHome ? '-1' : crumb.lbsId
        };

        const eventrefinements = crumb.types.join(',');

        if (eventrefinements.length > 0) {
            edapData.eventrefinements = eventrefinements;
        }

        pushEdapEvent('destination.link.click', edapData);
    };
}

export const BreadcrumbsComponent = (props) => {
    const {breadcrumbs} = props;

    return breadcrumbs ? (
        <Breadcrumbs
            crumbs={breadcrumbs}
            className="breadcrumbs container module module--xs-margin"
            isLastCrumbLinked
            onClickCrumbName={breadcrumbClickHandler(breadcrumbs)}
        />
    ) : null;
};


export const BreadCrumbs = connect(mapStateToProps)(BreadcrumbsComponent);
